import { gql } from '@apollo/client'

export const SAVE_GUIDE_HOLES_MUTATION = gql`
  mutation SaveGuideHoles($saveGuideHolesInput: [GuideHoleInput]!, $guideId: ID!) {
    GuidesMutation {
      saveGuideHoles(saveGuideHolesInput: $saveGuideHolesInput, guideId: $guideId)
    }
  }
`

export const SET_GUIDE_VISIBILITY_MUTATION = gql`
  mutation SetGuideVisibility($input: SetGuideVisibilityInput!) {
    GuidesMutation {
      setGuideVisibility(input: $input)
    }
  }
`

export const GET_CLUB_GUIDES_QUERY = gql`
  query GetClubGuides($clubId: ID!) {
    GuidesQuery {
      clubGuides(clubId: $clubId)
    }
  }
`

export const GET_APP_ORDERS_QUERY = gql`
  query GetAppOrders($clubId: ID!) {
    GuidesQuery {
      appOrders(clubId: $clubId)
    }
  }
`

export const SET_APP_ORDERS_MUTATION = gql`
  mutation SetAppOrders($clubId: ID!, $orders: [ID!]!) {
    GuidesMutation {
      setAppOrders(clubId: $clubId, orders: $orders)
    }
  }
`

export const GET_GUIDE_DRAWING_DATA_QUERY = gql`
  query GetGuideDrawingData($clubId: ID!, $guideId: ID!) {
    GuidesQuery {
      guideDrawingData(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const UPDATE_GUIDE_MUTATION = gql`
  mutation UpdateGuide($input: JSON!) {
    GuidesMutation {
      updateGuide(input: $input)
    }
  }
`

export const CREATE_GUIDE_MUTATION = gql`
  mutation CreateGuide($input: CreateGuideInput!) {
    GuidesMutation {
      createGuide(input: $input)
    }
  }
`

export const COPY_GUIDE_MUTATION = gql`
  mutation CopyGuide($clubId: ID!, $guideId: ID!, $input: JSON!) {
    GuidesMutation {
      copyGuide(clubId: $clubId, guideId: $guideId, input: $input)
    }
  }
`

export const DELETE_GUIDE_MUTATION = gql`
  mutation DeleteGuide($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      deleteGuide(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const UPLOAD_GUIDE_ICON_MUTATION = gql`
  mutation UploadGuideIcon($clubId: ID!, $guideId: ID!, $input: JSON!) {
    GuidesMutation {
      uploadGuideIcon(clubId: $clubId, guideId: $guideId, input: $input)
    }
  }
`

export const RELEASE_DIGITAL_GUIDE_MUTATION = gql`
  mutation ReleaseDigitalGuide($clubId: ID!, $guideId: ID!, $input: ReleaseDigitalGuideInput) {
    GuidesMutation {
      releaseDigitalGuide(clubId: $clubId, guideId: $guideId, input: $input)
    }
  }
`

export const RELEASE_OVERVIEW_MUTATION = gql`
  mutation ReleaseOverview($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      releaseOverview(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const RELEASE_WEB_IMAGES_MUTATION = gql`
  mutation ReleaseWebImages($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      releaseWebImages(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const RELEASE_GREEN_DRAWINGS_MUTATION = gql`
  mutation ReleaseGreenDrawings($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      releaseGreenDrawings(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const RELEASE_TEE_SIGNS_MUTATION = gql`
  mutation ReleaseTeeSigns($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      releaseTeeSigns(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const RELEASE_PDF_MUTATION = gql`
  mutation ReleasePdf($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      releasePdf(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const GET_WEB_IMAGES_LOCATION_MUTATION = gql`
  mutation GetWebImagesLocation($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      getWebImagesLocation(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const GET_TEE_SIGNS_LOCATION_MUTATION = gql`
  mutation GetTeeSignsLocation($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      getTeeSignsLocation(clubId: $clubId, guideId: $guideId)
    }
  }
`

export const GET_GREEN_DRAWINGS_LOCATION_MUTATION = gql`
  mutation GetGreenDrawingsLocation($clubId: ID!, $guideId: ID!) {
    GuidesMutation {
      getGreenDrawingsLocation(clubId: $clubId, guideId: $guideId)
    }
  }
`